module.exports = __webpack_public_path__ + "static/media/camera.02de51e7.svg";